import { createResourceReducer, typedResourceService } from './resourceReducer'

const { reducer, actions, thunks } = createResourceReducer({
    sliceName: 'videos',
    label: 'Video',
    service: typedResourceService('Video'),
})

export const { appendResource: appendVideo, destroyResource: destroyVideo, changeResource: changeVideo } = actions
export const { initializeResources: initializeVideos, deleteResource: deleteVideo, searchResources: searchVideos, refreshResource: refreshVideo } = thunks

// Children travel inline on the parent payload; the backend reconciles them by omission.
export const createVideo = (data, list) => thunks.createResource({ ...data, sub_videos: list || [] })

export const updateVideo = (id, data, videos, admin) => thunks.updateResource(id, { ...data, sub_videos: videos }, admin)

export default reducer
